import { FC, ReactNode } from 'react';
import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';

/** Small uppercase section heading above a field grid (e.g. "Approved values"). */
export const SectionLabel: FC<{ children: ReactNode }> = observer(({ children }) => (
  <Typography
    variant="textXS_bold"
    color="text.tertiary"
    sx={{
      textTransform: 'uppercase',
    }}
  >
    {children}
  </Typography>
));
